import { styled } from '@mui/material/styles';

export const Wrap = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 20,
  marginTop: 5,

  '& .MuiButtonBase-root': {
    minWidth: 155,
    minHeight: 44,
    height: 44,
    fontSize: 16,
    letterSpacing: '0.2px',
    fontWeight: 500
  }
});

export const PageTitle = styled('h1')({
  fontWeight: 600,
  fontSize: 32,
  margin: 0
});
